// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-page {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* Full width for mobile */
  padding: 0 20px;
}
.signup-page .signup-container {
  text-align: center;
  width: 100%; /* Full width for mobile */
}
.signup-page .signup-container h2 {
  font-size: 16px; /* Smaller font size for mobile */
  margin-bottom: 10px;
  line-height: 1.4;
}
.signup-page .signup-container .subtext {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}
.signup-page .signup-container .signup-form .form-group {
  margin-bottom: 20px;
  text-align: left;
}
.signup-page .signup-container .signup-form .form-group label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #333;
  font-family: BoldFont;
}
.signup-page .signup-container .signup-form .form-group input {
  width: 100%; /* Full width for mobile */
  padding: 12px;
  border: 1px solid #ddd;
  background-color: rgba(188, 187, 193, 0.2);
  border-radius: 10px;
  font-size: 14px;
  box-sizing: border-box;
}
.signup-page .signup-container .signup-form .form-group .password-input-container {
  position: relative;
}
.signup-page .signup-container .signup-form .form-group .password-input-container input {
  padding-right: 40px; /* Make room for the icon */
}
.signup-page .signup-container .signup-form .form-group .password-input-container .toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.signup-page .signup-container .signup-form .signup-button {
  width: 100%; /* Aligns with input fields */
  padding: 12px;
  background-color: var(--pmu-primary);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.signup-page .signup-container .signup-form .signup-button:hover {
  background-color: #6e1d6e; /* Darker shade of primary color */
}
.signup-page .signup-container .signup-form .signup-button:disabled {
  background: #ddd;
  cursor: not-allowed;
}

/* Tablet and larger screens */
@media (min-width: 768px) {
  .signup-page {
    width: 550px;
    margin: 40px auto;
  }
  .signup-container h2 {
    font-size: 18px;
  }
  .signup-container .subtext {
    font-size: 16px;
  }
  .signup-container .signup-form .form-group input {
    font-size: 16px;
    padding: 14px;
  }
  .signup-container .signup-form .form-group .password-input-container input {
    padding-right: 45px; /* Adjust for larger screens */
  }
  .signup-container .signup-form .signup-button {
    font-size: 18px;
    padding: 14px;
  }
}
/* Desktop and larger screens */
@media (min-width: 1024px) {
  .signup-page {
    width: 600px;
    margin: 50px auto;
  }
}
.error {
  color: red;
  font-size: 14px;
  margin-top: 5px;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/pages/authpage/authsubfolders/signUp/signup.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA,EAAA,0BAAA;EACA,eAAA;AACF;AACE;EACE,kBAAA;EACA,WAAA,EAAA,0BAAA;AACJ;AACI;EACE,eAAA,EAAA,iCAAA;EACA,mBAAA;EACA,gBAAA;AACN;AAEI;EACE,eAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAAN;AAIM;EACE,mBAAA;EACA,gBAAA;AAFR;AAIQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AAFV;AAKQ;EACE,WAAA,EAAA,0BAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;AAHV;AAMQ;EACE,kBAAA;AAJV;AAMU;EACE,mBAAA,EAAA,2BAAA;AAJZ;AAOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AALZ;AAUM;EACE,WAAA,EAAA,6BAAA;EACA,aAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AARR;AAUQ;EACE,yBAAA,EAAA,kCAAA;AARV;AAWQ;EACE,gBAAA;EACA,mBAAA;AATV;;AAgBA,8BAAA;AACA;EACE;IACE,YAAA;IACA,iBAAA;EAbF;EAiBE;IACE,eAAA;EAfJ;EAkBE;IACE,eAAA;EAhBJ;EAqBM;IACE,eAAA;IACA,aAAA;EAnBR;EAsBM;IACE,mBAAA,EAAA,8BAAA;EApBR;EAwBI;IACE,eAAA;IACA,aAAA;EAtBN;AACF;AA2BA,+BAAA;AACA;EACE;IACE,YAAA;IACA,iBAAA;EAzBF;AACF;AA4BA;EACE,UAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA1BF","sourcesContent":[".signup-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%; /* Full width for mobile */\n  padding: 0 20px;\n\n  .signup-container {\n    text-align: center;\n    width: 100%; /* Full width for mobile */\n\n    h2 {\n      font-size: 16px; /* Smaller font size for mobile */\n      margin-bottom: 10px;\n      line-height: 1.4;\n    }\n\n    .subtext {\n      font-size: 14px;\n      color: #666;\n      margin-bottom: 20px;\n      line-height: 1.5;\n    }\n\n    .signup-form {\n      .form-group {\n        margin-bottom: 20px;\n        text-align: left;\n\n        label {\n          display: block;\n          margin-bottom: 8px;\n          font-size: 14px;\n          color: #333;\n          font-family: BoldFont;\n        }\n\n        input {\n          width: 100%; /* Full width for mobile */\n          padding: 12px;\n          border: 1px solid #ddd;\n          background-color: #bcbbc133;\n          border-radius: 10px;\n          font-size: 14px;\n          box-sizing: border-box;\n        }\n\n        .password-input-container {\n          position: relative;\n\n          input {\n            padding-right: 40px; /* Make room for the icon */\n          }\n\n          .toggle-password {\n            position: absolute;\n            right: 12px;\n            top: 50%;\n            transform: translateY(-50%);\n            background: none;\n            border: none;\n            cursor: pointer;\n            color: #666;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            padding: 0;\n          }\n        }\n      }\n\n      .signup-button {\n        width: 100%; /* Aligns with input fields */\n        padding: 12px;\n        background-color: var(--pmu-primary);\n        color: #fff;\n        border: none;\n        border-radius: 10px;\n        font-size: 16px;\n        cursor: pointer;\n        transition: background-color 0.3s;\n\n        &:hover {\n          background-color: #6e1d6e; /* Darker shade of primary color */\n        }\n\n        &:disabled {\n          background: #ddd;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n}\n\n/* Tablet and larger screens */\n@media (min-width: 768px) {\n  .signup-page {\n    width: 550px;\n    margin: 40px auto;\n  }\n\n  .signup-container {\n    h2 {\n      font-size: 18px;\n    }\n\n    .subtext {\n      font-size: 16px;\n    }\n\n    .signup-form {\n      .form-group {\n        input {\n          font-size: 16px;\n          padding: 14px;\n        }\n\n        .password-input-container input {\n          padding-right: 45px; /* Adjust for larger screens */\n        }\n      }\n\n      .signup-button {\n        font-size: 18px;\n        padding: 14px;\n      }\n    }\n  }\n}\n\n/* Desktop and larger screens */\n@media (min-width: 1024px) {\n  .signup-page {\n    width: 600px;\n    margin: 50px auto;\n  }\n}\n\n.error {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
